import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import Logo from "@/components/Logo";
import { LogIn } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/admin");
    else setError(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen bg-brand-surface flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Logo />
        </div>
        <div className="bg-white border border-brand-border rounded-3xl p-8 sm:p-10">
          <h1 className="font-display font-bold text-2xl text-brand-ink" data-testid="admin-login-title">Admin Sign In</h1>
          <p className="text-sm text-brand-muted mt-1">Access the TelstraNics dashboard.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
            <label className="block">
              <span className="text-sm font-medium text-brand-ink mb-1.5 block">Email</span>
              <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email"
                className="w-full px-4 py-3 rounded-xl border border-brand-border focus:outline-none focus:border-brand-ink focus:ring-4 focus:ring-brand-blue/10" placeholder="admin@telstranics.com" />
            </label>
            <label className="block">
              <span className="text-sm font-medium text-brand-ink mb-1.5 block">Password</span>
              <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password"
                className="w-full px-4 py-3 rounded-xl border border-brand-border focus:outline-none focus:border-brand-ink focus:ring-4 focus:ring-brand-blue/10" placeholder="••••••••" />
            </label>
            {error && <div className="text-sm text-red-600" data-testid="admin-login-error">{error}</div>}
            <button disabled={loading} data-testid="admin-login-submit" className="btn-primary w-full">
              {loading ? "Signing in..." : (<>Sign In <LogIn className="w-4 h-4" /></>)}
            </button>
          </form>
        </div>
        <div className="text-center mt-6">
          <a href="/" className="text-sm text-brand-muted hover:text-brand-ink" data-testid="admin-login-home">← Back to site</a>
        </div>
      </div>
    </div>
  );
}
